import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxPaginationModule } from 'ngx-pagination';

import { FeatureCardDefaultModule } from '@unico-people/shared/dashboard/feature-card-default';
import { UiProfileSidebarModule } from '@unico-people/shared/dashboard/ui-profile-sidebar';
import { HeaderModule } from '../../components/header/header.module';
import { EmployeeProfileRoutingModule } from './employee-profile-routing.module';
import { DadosColaboradorModule } from '../../components/dados-colaborador/dados-colaborador.module';
import { InfosContatoColabModule } from '../../components/infos-contato-colab/infos-contato-colab.module';
import { InfosAddColabModule } from '../../components/infos-add-colab/infos-add-colab.module';

import { UiCopyButtonModule } from '@unico-people/shared/dashboard/ui-copy-button';

import { EmployeeContractualInfosComponent } from './employee-contractual-infos/employee-contractual-infos.component';
import { EmployeeProfileComponent } from './employee-profile.component';
import { EmployeeActivitiesComponent } from './employee-activities/employee-activities.component';
import { EmployeeSignaturesComponent } from './employee-signatures/employee-signatures.component';
import { ItemEnvelopeDocumentModule } from '../../components/item-envelope-document/item-envelope-document.module';
import { SidebarEnvelopeDocumentModule } from '../../components/sidebar-envelope-document/sidebar-envelope-document.module';
import { FeaturePaginationModule } from '@unico-people/shared/dashboard/feature-pagination';
import { EnvelopeSimpleShippingModule } from '../../components/envelope-simple-shipping/envelope-simple-shipping.module';

@NgModule({
  declarations: [EmployeeContractualInfosComponent, EmployeeActivitiesComponent, EmployeeProfileComponent, EmployeeSignaturesComponent],
  exports: [EmployeeContractualInfosComponent, EmployeeActivitiesComponent, EmployeeProfileComponent, EmployeeSignaturesComponent],
  imports: [
    CommonModule,
    RouterModule,
    EmployeeProfileRoutingModule,
    MatDialogModule,
    HeaderModule,
    UiProfileSidebarModule,
    FeatureCardDefaultModule,
    InfosContatoColabModule,
    DadosColaboradorModule,
    InfosAddColabModule,
    UiCopyButtonModule,
    ItemEnvelopeDocumentModule,
    SidebarEnvelopeDocumentModule,
    FeaturePaginationModule,
    NgxPaginationModule,
    EnvelopeSimpleShippingModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class EmployeeProfileModule {}
